export const formatToSelectValues = options => {
    return Object.values(options).map(item => {
        return {
            value: item.value,
            label: item.label
        }
    })
    
}


// WEBPACK FOOTER //
// ./src/views/utils/helpers.js